/**
 * 关页 / 刷新时尽力 POST current/clear（fetch + keepalive），不清 MQTT、不停会话心跳。
 */

import { ApiClient } from '../utils/apiClient';

const CLEAR_CURRENT_GROUP_PATH = '/userGroup/current/clear';

function clearCurrentGroupOnPageHide(): void {
  const token = ApiClient.getAuthToken();
  if (!token) return;

  fetch(`${ApiClient.getBaseUrl()}${CLEAR_CURRENT_GROUP_PATH}`, {
    method: 'POST',
    keepalive: true,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: '{}',
  }).catch(() => {
    // 页面卸载中无法可靠处理响应
  });
}

/** 应用入口注册一次；返回 teardown */
export function registerVoiceGroupPageHideCleanup(): () => void {
  window.addEventListener('pagehide', clearCurrentGroupOnPageHide);
  return () => {
    window.removeEventListener('pagehide', clearCurrentGroupOnPageHide);
  };
}
